<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <sarala-table
                    :model="model"
                    ref="table"
                    :cellPadding="true"
                    :sort="{
                        sortDesc: false,
                        prop: 'statusText',
                    }"
                    :exportable="true"
                >
                    <template #reseller="{ item }">
                        <span class="subtitle-1">
                            {{ item.reseller.partnerType }}
                        </span>
                        <br />
                        <span class="caption">
                            {{ $t('customer.index.table.trade-name') }}:
                        </span>
                        <span class="body-2 font-weight-medium">
                            {{ item.reseller.trade_name }}
                        </span>
                    </template>

                    <template #trade_name="{ item }">
                        <template v-if="item.cnpj">
                            <span class="caption">
                                {{ $t('customer.index.table.trade-name') }}:
                            </span>
                            <span class="body-2 font-weight-medium">
                                {{ item.trade_name }}
                            </span>
                            <br />
                            <span class="caption">
                                {{ $t('customer.index.table.legal-name') }}:
                            </span>
                            <span class="body-2">{{ item.legal_name }}</span>
                            <br />
                        </template>

                        <template v-else>
                            <span class="caption">
                                {{ $t('customer.index.table.name') }}:
                            </span>
                            <span class="body-2 font-weight-medium">
                                {{ item.trade_name }}
                            </span>
                            <br />
                        </template>

                        <span class="caption">
                            {{ $t('customer.index.table.document') }}:
                        </span>
                        <span class="body-2">{{ item.document }}</span>
                        <br />

                        <span class="caption"
                            >{{ $t('customer.expanded.login-code') }}:
                        </span>
                        <span class="body-2">{{ item.erp_login_code }}</span>
                        <br />
                        <span class="caption">Schema: </span>
                        <span class="body-2">{{ item.erp_contract_id }}</span>
                    </template>

                    <template #active_at="{ item }">{{
                        item.formattedActiveAt
                    }}</template>

                    <template #deleted_at="{ item }">{{
                        item.formattedDeletedAt
                    }}</template>

                    <template #actionHandler>
                        <CustomerActions
                            ref="actionHandler"
                            @modelChanged="$refs.table.getItems()"
                        />
                    </template>
                </sarala-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import CustomerActions from '@/components/actions/customer/CustomerActions'
import Customer from '@/models/Customer'
import SaralaTable from '@/shared/components/SaralaTable'

export default {
    components: {
        CustomerActions,
        SaralaTable,
    },

    computed: {
        model() {
            return new Customer()
        },
    },

    methods: {
        async fetchResellerTypes() {
            let types = await this.resellerType.all()
            this.resellerTypes = types.data
        },
    },
}
</script>
